import React, { Fragment } from 'react';
import { AITopicsByPerson } from '../../../../../ai-topics';
import { messages } from '../../../../../messages';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import { getTypedJSONResultDataAssistanceService } from '../../../../utils/getTypedJSONResultData';
import { RecentWorkList } from '../recent-work-list';
import { ProfileSection } from '../user-profile-section';
import { AIAnswerWhoSection } from './who-result-section';
export var AIAnswerWhoResult = function AIAnswerWhoResult() {
  var _primaryUser$account_, _primaryUser$collabor;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    isAdminHubAIEnabled = _useAIAnswerContext.isAdminHubAIEnabled;
  var answerString = commonAttributes.answerString,
    cloudId = commonAttributes.cloudId,
    sessionId = commonAttributes.sessionId;
  var aiTopicsEnabled = isAdminHubAIEnabled;

  // answerString should have at least one result or else <AIAnswerError /> will be rendered
  var whoResult = {
    user_metadata: getTypedJSONResultDataAssistanceService(answerString).parsedResult
  };
  var userResults = whoResult.user_metadata;
  // BE will always return first object as the primary user result
  var primaryUser = userResults[0];
  var frequentLocationsSection = /*#__PURE__*/React.createElement(AIAnswerWhoSection, {
    sectionId: "frequent_locations",
    sectionHeader: messages.ai_answer_who_questions_frequent_locations_header,
    sectionResults: primaryUser.containers,
    avatarAppearance: "square"
  });
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProfileSection, {
    accountId: primaryUser.account_id,
    name: primaryUser.name,
    email: primaryUser.email,
    avatarUrl: primaryUser.avatar_url,
    profileUrl: primaryUser.profile_url,
    jobTitle: primaryUser.job_title,
    department: primaryUser.department,
    location: primaryUser.location,
    time: primaryUser.time
  }), aiTopicsEnabled ? /*#__PURE__*/React.createElement(AITopicsByPerson, {
    cloudId: cloudId,
    userId: (_primaryUser$account_ = primaryUser.account_id) !== null && _primaryUser$account_ !== void 0 ? _primaryUser$account_ : '',
    userName: primaryUser.name,
    sessionId: sessionId,
    fallbackSection: frequentLocationsSection
  }) : /*#__PURE__*/React.createElement(Fragment, null, frequentLocationsSection), /*#__PURE__*/React.createElement(AIAnswerWhoSection, {
    sectionId: "frequent_collaborators",
    sectionHeader: messages.ai_answer_who_questions_frequent_collaborators_header,
    sectionResults: (_primaryUser$collabor = primaryUser.collaborators) === null || _primaryUser$collabor === void 0 ? void 0 : _primaryUser$collabor.slice(0, 3),
    avatarAppearance: "circle"
  }), /*#__PURE__*/React.createElement(AIAnswerWhoSection, {
    sectionId: "teams",
    sectionHeader: messages.ai_answer_who_questions_teams_header,
    sectionResults: primaryUser.teams,
    avatarAppearance: "square"
  }), primaryUser.recentActivity && /*#__PURE__*/React.createElement(RecentWorkList, {
    name: primaryUser.name,
    activities: primaryUser.recentActivity,
    viewAllUrl: primaryUser.viewAllLink
  }));
};